var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-default" }, [
    _c("div", { staticClass: "panel-heading" }, [
      _vm._v("\n    Dados do Veículo\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "panel-body" }, [
      _c(
        "form",
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Nome do Veículo")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("small", [
                _vm._v(
                  "Verifique se o veículo que você vai sugerir consta na nossa base. Digite o nome e veja se há\n          algum correspondente. Você pode enviar novas informações ou dados atualizados sobre o mesmo\n          veículo."
                )
              ]),
              _vm._v(" "),
              _c("v-auto-complete", {
                attrs: { service: _vm.suggestionService, "is-async": true },
                on: { input: _vm.updateForm, onSetValue: _vm.getMediaData },
                model: {
                  value: _vm.media.media,
                  callback: function($$v) {
                    _vm.$set(_vm.media, "media", $$v)
                  },
                  expression: "media.media"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [
              _vm._v(
                "Este veículo é exclusivamente um blog, site pessoal ou página pessoal em rede\n          social? "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                'Assinale "Sim" apenas para sites e blogs que sejam independentes de grandes grupos de mídia.\n          Ex. blogs dentro de grandes jornais são "Não"'
              )
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.media.paid_site,
                    expression: "media.paid_site"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.media,
                        "paid_site",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.updatePaidSite
                  ]
                }
              },
              _vm._l(_vm.paidSiteOptions, function(opt) {
                return _c(
                  "option",
                  { key: opt.value, domProps: { value: opt.value } },
                  [_vm._v("\n            " + _vm._s(opt.text) + "\n          ")]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.media.paid_site === 1,
                  expression: "media.paid_site === 1"
                }
              ],
              staticClass: "platform-native-fields"
            },
            [
              _c("h4", [
                _vm._v(
                  "Informações específicas para blogs, sites pessoais e páginas em redes sociais"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "help-block" }, [
                _vm._v(
                  "\n          Preencha estes campos adicionais apenas quando o veículo indicado for exclusivamente um blog,\n          site pessoal ou página pessoal em rede social.\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Ano de início da iniciativa")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.media.initiative_start_year,
                      expression: "media.initiative_start_year"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", min: "1800" },
                  domProps: { value: _vm.media.initiative_start_year },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.media,
                          "initiative_start_year",
                          $event.target.value
                        )
                      },
                      _vm.updateForm
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Principal tema de cobertura")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.main_coverage_topic,
                        expression: "media.main_coverage_topic"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.media,
                            "main_coverage_topic",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("\n              Selecione\n            ")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.coverageTopics, function(opt) {
                      return _c(
                        "option",
                        { key: opt.value, domProps: { value: opt.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(opt.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Outros temas de cobertura")]),
                  _vm._v(" "),
                  _c("small", [_vm._v("Pode marcar mais de uma alternativa")]),
                  _vm._v(" "),
                  _c("v-check-box-group", {
                    attrs: { options: _vm.coverageTopics },
                    on: { input: _vm.updateForm },
                    model: {
                      value: _vm.media.other_coverage_topics,
                      callback: function($$v) {
                        _vm.$set(_vm.media, "other_coverage_topics", $$v)
                      },
                      expression: "media.other_coverage_topics"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Público-alvo")]),
                  _vm._v(" "),
                  _c("v-check-box-group", {
                    attrs: { options: _vm.targetAudiences },
                    on: { input: _vm.updateForm },
                    model: {
                      value: _vm.media.target_audiences,
                      callback: function($$v) {
                        _vm.$set(_vm.media, "target_audiences", $$v)
                      },
                      expression: "media.target_audiences"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Abrangência de cobertura")]),
                  _vm._v(" "),
                  _c("v-check-box-group", {
                    attrs: { options: _vm.coverageScopes },
                    on: { input: _vm.updateForm },
                    model: {
                      value: _vm.media.coverage_scopes,
                      callback: function($$v) {
                        _vm.$set(_vm.media, "coverage_scopes", $$v)
                      },
                      expression: "media.coverage_scopes"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Produz conteúdo original?")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.produces_original_content,
                        expression: "media.produces_original_content"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.media,
                            "produces_original_content",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("\n              Selecione\n            ")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.yesNoOptions, function(opt) {
                      return _c(
                        "option",
                        { key: opt.value, domProps: { value: opt.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(opt.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Plataforma principal")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.primary_platform,
                        expression: "media.primary_platform"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.media,
                            "primary_platform",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("\n              Selecione\n            ")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.platformOptions, function(opt) {
                      return _c(
                        "option",
                        { key: opt.value, domProps: { value: opt.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(opt.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v("Número de seguidores da plataforma principal")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.media.primary_platform_followers,
                      expression: "media.primary_platform_followers"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", min: "0" },
                  domProps: { value: _vm.media.primary_platform_followers },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.media,
                          "primary_platform_followers",
                          $event.target.value
                        )
                      },
                      _vm.updateForm
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Plataforma secundária")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.secondary_platform,
                        expression: "media.secondary_platform"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.media,
                            "secondary_platform",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("\n              Selecione\n            ")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.platformOptions, function(opt) {
                      return _c(
                        "option",
                        { key: opt.value, domProps: { value: opt.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(opt.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v("Número de seguidores da plataforma secundária")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.media.secondary_platform_followers,
                      expression: "media.secondary_platform_followers"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", min: "0" },
                  domProps: { value: _vm.media.secondary_platform_followers },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.media,
                          "secondary_platform_followers",
                          $event.target.value
                        )
                      },
                      _vm.updateForm
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Pessoa de contato")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.media.contact_person,
                      expression: "media.contact_person"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.media.contact_person },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.media,
                          "contact_person",
                          $event.target.value
                        )
                      },
                      _vm.updateForm
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Email da pessoa de contato")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.media.contact_person_email,
                      expression: "media.contact_person_email"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "email" },
                  domProps: { value: _vm.media.contact_person_email },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.media,
                          "contact_person_email",
                          $event.target.value
                        )
                      },
                      _vm.updateForm
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("WhatsApp da pessoa de contato")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.media.contact_person_whatsapp,
                      expression: "media.contact_person_whatsapp"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.media.contact_person_whatsapp },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.media,
                          "contact_person_whatsapp",
                          $event.target.value
                        )
                      },
                      _vm.updateForm
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Tem um jornalista responsável?")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.has_responsible_journalist,
                        expression: "media.has_responsible_journalist"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.media,
                            "has_responsible_journalist",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("\n              Selecione\n            ")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.yesNoOptions, function(opt) {
                      return _c(
                        "option",
                        { key: opt.value, domProps: { value: opt.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(opt.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.media.has_responsible_journalist === 1,
                      expression: "media.has_responsible_journalist === 1"
                    }
                  ],
                  staticClass: "form-group"
                },
                [
                  _c("label", [_vm._v("Nome do jornalista responsável")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.responsible_journalist_name,
                        expression: "media.responsible_journalist_name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.media.responsible_journalist_name },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.media,
                            "responsible_journalist_name",
                            $event.target.value
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Já sofreu assédio judicial?")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.has_suffered_legal_harassment,
                        expression: "media.has_suffered_legal_harassment"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.media,
                            "has_suffered_legal_harassment",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("\n              Selecione\n            ")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.yesNoOptions, function(opt) {
                      return _c(
                        "option",
                        { key: opt.value, domProps: { value: opt.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(opt.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Já teve o canal suspenso?")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.has_had_channel_suspended,
                        expression: "media.has_had_channel_suspended"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.media,
                            "has_had_channel_suspended",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("\n              Selecione\n            ")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.yesNoOptions, function(opt) {
                      return _c(
                        "option",
                        { key: opt.value, domProps: { value: opt.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(opt.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Recebe repasses das plataformas?")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.receives_platform_transfers,
                        expression: "media.receives_platform_transfers"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.media,
                            "receives_platform_transfers",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("\n              Selecione\n            ")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.yesNoOptions, function(opt) {
                      return _c(
                        "option",
                        { key: opt.value, domProps: { value: opt.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(opt.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Acessibilidade")]),
                  _vm._v(" "),
                  _c("v-check-box-group", {
                    attrs: { options: _vm.accessibilityOptions },
                    on: { input: _vm.updateForm },
                    model: {
                      value: _vm.media.accessibility_features,
                      callback: function($$v) {
                        _vm.$set(_vm.media, "accessibility_features", $$v)
                      },
                      expression: "media.accessibility_features"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Como descreve o canal?")]),
                  _vm._v(" "),
                  _c("v-check-box-group", {
                    attrs: { options: _vm.channelDescriptionOptions },
                    on: { input: _vm.updateForm },
                    model: {
                      value: _vm.media.channel_descriptions,
                      callback: function($$v) {
                        _vm.$set(_vm.media, "channel_descriptions", $$v)
                      },
                      expression: "media.channel_descriptions"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Dá acesso aos princípios editoriais?")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.has_editorial_principles,
                        expression: "media.has_editorial_principles"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.media,
                            "has_editorial_principles",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("\n              Selecione\n            ")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.yesNoOptions, function(opt) {
                      return _c(
                        "option",
                        { key: opt.value, domProps: { value: opt.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(opt.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.media.has_editorial_principles === 1,
                      expression: "media.has_editorial_principles === 1"
                    }
                  ],
                  staticClass: "form-group"
                },
                [
                  _c("label", [_vm._v("Link para os princípios editoriais")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.editorial_principles_link,
                        expression: "media.editorial_principles_link"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "url" },
                    domProps: { value: _vm.media.editorial_principles_link },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.media,
                            "editorial_principles_link",
                            $event.target.value
                          )
                        },
                        _vm.updateForm
                      ]
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Tipologia do conteúdo")]),
                  _vm._v(" "),
                  _c("v-check-box-group", {
                    attrs: { options: _vm.contentTypologyOptions },
                    on: { input: _vm.updateForm },
                    model: {
                      value: _vm.media.content_typologies,
                      callback: function($$v) {
                        _vm.$set(_vm.media, "content_typologies", $$v)
                      },
                      expression: "media.content_typologies"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Este veículo é um meio de jornalismo?")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                "Caso veículo seja um meio de jornalismo assinale SIM. Caso seja um veículo ligado a\n          instituições públicas como Prefeituras e Estados ou organizações não jornalísticas (como\n          sindicatos, associações e empresas não jornalísticas), assinale NÃO."
              )
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.media.journalism,
                    expression: "media.journalism"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.media,
                        "journalism",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.updateForm
                  ]
                }
              },
              _vm._l(_vm.journalismChoices, function(opt) {
                return _c(
                  "option",
                  { key: opt.value, domProps: { value: opt.value } },
                  [_vm._v("\n            " + _vm._s(opt.text) + "\n          ")]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Cidade-sede do veículo ")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("small", [
                _vm._v(
                  "Coloque apenas o nome da cidade do veículo (sem o Estado). Certifique-se de que o nome esteja\n          escrito corretamente, porque erros de digitação podem anular, ou no mínimo dificultar, a\n          validação de sua sugestão."
                )
              ]),
              _vm._v(" "),
              _c("v-auto-complete", {
                attrs: {
                  options: _vm.cities,
                  service: _vm.cityService,
                  "is-async": true
                },
                on: { input: _vm.updateForm },
                model: {
                  value: _vm.city,
                  callback: function($$v) {
                    _vm.city = $$v
                  },
                  expression: "city"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Endereço")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                "Por favor, forneça o logradouro onde o veículo tem sede, caso disponível"
              )
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.media.address,
                  expression: "media.address"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.media.address },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.media, "address", $event.target.value)
                  },
                  _vm.updateForm
                ]
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Segmento PRINCIPAL do veículo de imprensa")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                'Favor assinalar o PRINCIPAL. Ex. se um veículo é mais conhecido por seu jornal, mas também\n          tem um site, assinale "Jornal". Se for exclusivamente digital, assinale "Online". Se for "blog"\n          ou uma "revista online", assinale "Online" também, mas se houver versão impressa, assinale\n          "Revista". Agências de notícia e newsletters são "Online". E assim vai...'
              )
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.media.segment_id,
                    expression: "media.segment_id"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.media,
                        "segment_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.updateForm
                  ]
                }
              },
              _vm._l(_vm.segments, function(opt) {
                return _c(
                  "option",
                  { key: opt.value, domProps: { value: opt.value } },
                  [_vm._v("\n            " + _vm._s(opt.text) + "\n          ")]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [
                _vm._v(
                  "Quais as características desse veículo, onde se destaca?"
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("small", [_vm._v("Pode marcar mais de uma alternativa")]),
              _vm._v(" "),
              _c("v-check-box-group", {
                attrs: { options: _vm.features },
                model: {
                  value: _vm.media.features,
                  callback: function($$v) {
                    _vm.$set(_vm.media, "features", $$v)
                  },
                  expression: "media.features"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Modelo de negócios do veículo")]),
              _vm._v(" "),
              _c("v-check-box-group", {
                attrs: { options: _vm.businessModels },
                model: {
                  value: _vm.media.businessModels,
                  callback: function($$v) {
                    _vm.$set(_vm.media, "businessModels", $$v)
                  },
                  expression: "media.businessModels"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [
              _vm._v(
                "Qual o tamanho do quadro de funcionários/colaboradores, incluindo jornalistas e profissionais\n          de outras áreas?"
              )
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.media.employees_range_id,
                    expression: "media.employees_range_id"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.media,
                        "employees_range_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.updateForm
                  ]
                }
              },
              _vm._l(_vm.employeesRanges, function(opt) {
                return _c(
                  "option",
                  { key: opt.value, domProps: { value: opt.value } },
                  [_vm._v("\n            " + _vm._s(opt.text) + "\n          ")]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [
              _vm._v(
                "Periodicidade: qual a frequência de publicação ou transmissão desse veículo"
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                "Ex. para boa parte das emissoras de televisão, a periodicidade é diária"
              )
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.media.periodicity,
                    expression: "media.periodicity"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.media,
                        "periodicity",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.updateForm
                  ]
                }
              },
              _vm._l(_vm.periodicities, function(opt) {
                return _c(
                  "option",
                  { key: opt.value, domProps: { value: opt.value } },
                  [_vm._v("\n            " + _vm._s(opt.text) + "\n          ")]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.media.periodicity === "another",
                  expression: "media.periodicity === 'another'"
                }
              ],
              staticClass: "form-group"
            },
            [
              _c("label", [_vm._v("Qual a periodicidade?")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.media.another_periodicity,
                    expression: "media.another_periodicity"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.media.another_periodicity },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.media,
                        "another_periodicity",
                        $event.target.value
                      )
                    },
                    _vm.updateForm
                  ]
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Propriedade do veículo")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("small", [
                _vm._v(
                  "Escreva aqui o nome do grupo econômico ou do proprietário do veículo, buscando sempre que\n          possível indicando um link que prove isso. Ex. site da organização, processo judicial, WHOIS,\n          etc"
                )
              ]),
              _vm._v(" "),
              _c("v-auto-complete", {
                attrs: { service: _vm.sponsorService, "is-async": true },
                on: { input: _vm.updateForm },
                model: {
                  value: _vm.media.sponsor,
                  callback: function($$v) {
                    _vm.$set(_vm.media, "sponsor", $$v)
                  },
                  expression: "media.sponsor"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Email geral do veículo")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.media.email,
                  expression: "media.email"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.media.email },
              on: {
                change: _vm.updateForm,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.media, "email", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Observação/Notas")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                "Escreva aqui qualquer observação que tenha. Ex. se seu veículo cobre outra cidade além de\n          onde é sediado."
              )
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.media.annotations,
                  expression: "media.annotations"
                }
              ],
              staticClass: "form-control",
              domProps: { value: _vm.media.annotations },
              on: {
                change: _vm.updateForm,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.media, "annotations", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm._l(_vm.channels, function(channel, i) {
            return _c("div", { key: i, staticClass: "form-group" }, [
              _c("label", [
                _vm._v("Link para o " + _vm._s(channel.text) + " do Veículo")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("small", [_vm._v(_vm._s(channel.hint))]),
              _vm._v(" "),
              _vm.media.mediaChannels.length > 0
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.media.mediaChannels[i].link,
                        expression: "media.mediaChannels[i].link"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.media.mediaChannels[i].link },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.media.mediaChannels[i],
                            "link",
                            $event.target.value
                          )
                        },
                        function($event) {
                          return _vm.updateChannel($event, i)
                        }
                      ]
                    }
                  })
                : _vm._e()
            ])
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Você é")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                "Assinale uma das categorias abaixo que mais se enquadra com seu perfil. Esse campo é\n          importante para nos ajudar na validação dos dados e entendermos o interesse da participação na\n          pesquisa.\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.media.collaborator_id,
                    expression: "media.collaborator_id"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.media,
                        "collaborator_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.updateForm
                  ]
                }
              },
              _vm._l(_vm.collaborators, function(opt) {
                return _c(
                  "option",
                  { key: opt.value, domProps: { value: opt.value } },
                  [_vm._v("\n            " + _vm._s(opt.text) + "\n          ")]
                )
              }),
              0
            )
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }